
import request from "@/untils/request.js"

export const getPhrWalletPage = (params) => {
    return request.get("/outpatient/phrWallet/page", {params} )
}

export const phrWallet= (data) => {
    return request.post("/outpatient/phrWallet", data )
}

export const getAmtById= (id) => {
    return request.get(`/outpatient/phrWallet/getAmt/${id}` )
}

export const phrWalletTrading= (id) => {
    return request.get(`/outpatient/phrWallet/nuy/${id}` )
}
